var $1c23cdb9fed8626b$exports = {};
$1c23cdb9fed8626b$exports = {
    "valid": `\u{414}\u{456}\u{439}\u{441}\u{43D}\u{438}\u{439}`
};


export {$1c23cdb9fed8626b$exports as default};
//# sourceMappingURL=uk-UA.mjs.map
